import React from "react";
import mhcLogo from "../../assets/images/boots-myhealthchecked-logo.svg";
import PropTypes from "prop-types";
import { useAuth } from "../../components/AuthContext/AuthContext";

const AccountCard = ({
  children,
  loginPage = false,
  welcomePage = false,
  title = "Log in",
  subtitle = " ",
}) => {
  const path = globalThis.location.pathname;
  const {featureFlagLoading, featureFlag} = useAuth();

  return (
      <div className="container main-login-container">
        <div
          className={`row login-page ${
            path === "/login" ? "login-landing-page" : ""
          } ${!featureFlagLoading && featureFlag && "vh-login-form"}`}
        >
        {!featureFlagLoading && featureFlag ? (
          <div className="col-md-12">
            <div className="d-flex align-items-center justify-content-center flex-column account-card-wrapper my-0">
              <div className="account-card-heading">
                <h3>{title}</h3>
                {subtitle && <p>{subtitle}</p>}
              </div>
              <div
                className={` account-card px-0 ${welcomePage && "welcome-card"}`}
                style={
                  welcomePage ? { marginTop: "95px", marginBottom: "62px" } : {}
                }
              >
                <div className="card-body p-0 d-flex align-items-center justify-content-center flex-row">
                  <div className="container-fluid">
                    <div className="row">
                      <div className={`col-12 px-0`}>
                        {children}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>):(
            <div className="col-md-12">
            <div className="d-flex align-items-center justify-content-center flex-column account-card-wrapper">
              {path === "/login" && 
              <img
                className="mt-auto logo-layout"
                src={mhcLogo}
                alt="mhc-logo"
              />}
              <div className={`card account-card ${welcomePage && "welcome-card"}`}  style={welcomePage ? { marginTop: "95px", marginBottom:"62px" } : {}}>
                <div className="card-body p-0 d-flex align-items-center justify-content-center flex-row">
                  <div className="container-fluid">
                    <div className="row">
                      <div
                        className={`col-12`}
                      >
                        {loginPage && (
                          <div className="title-wrapper">
                            <p className="login-form-title">{title}</p>
                          </div>
                        )}
                        {children}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          )
        }
        </div>
      </div>
  );
};

AccountCard.propTypes = {
  children: PropTypes.node,
  loginPage: PropTypes.bool,
  welcomePage: PropTypes.bool,
  title: PropTypes.string,
};
export default AccountCard;
